import type { SettingsTranslations } from "../interfaces/settings";

export const settingsTranslations: SettingsTranslations = {
  title_page: "Ajustes",
  language_label: "Idioma",
  general_settings_title: "General",
  domain_settings_title: "Dominio",
  integrations_settings_title: "Integraciones",

  // Page-level
  settings_eyebrow_account: "Cuenta",
  settings_subtitle: "Tema, idioma y seguridad de tu cuenta de Coloca payments",
  settings_nav_on_this_page: "En esta página",
  settings_group_preferences: "Preferencias",
  settings_group_security: "Seguridad",
  settings_group_developers: "Desarrolladores",
  settings_group_alerts: "Avisos",
  settings_group_account: "Cuenta",

  // Secciones
  appearance_section_title: "Apariencia",
  appearance_section_description: "Personaliza la interfaz de la aplicación",
  language_section_title: "Idioma y región",
  language_section_description: "Define el idioma de la interfaz y la zona horaria de tus reportes.",
  security_section_title: "Seguridad",
  security_section_description: "Protege tu cuenta con autenticación de dos factores",

  // Dispositivos
  devices_section_title: "Sesiones activas",
  devices_section_eyebrow: "Dispositivos",
  devices_section_subtitle: "Lista de dispositivos donde tu cuenta está abierta.",
  devices_badge_current: "ACTUAL",
  devices_action_revoke: "Cerrar sesión",
  devices_action_revoke_others: "Cerrar todas las demás sesiones",
  devices_confirm_revoke_title: "¿Cerrar esta sesión?",
  devices_confirm_revoke_body:
    "El dispositivo {{device}} dejará de tener acceso de inmediato. Tendrás que volver a iniciar sesión desde ahí.",
  devices_confirm_revoke: "Cerrar sesión",
  devices_confirm_revoke_others_title: "¿Cerrar todas las demás sesiones?",
  devices_confirm_revoke_others_body:
    "Cerrarás {{n}} sesión(es) en otros dispositivos. Tu sesión actual no se verá afectada.",
  devices_confirm_revoke_others: "Cerrar las demás",
  devices_confirm_cancel: "Cancelar",
  devices_last_seen_now: "Ahora",
  devices_last_seen_minutes: "Hace {{n}} min",
  devices_last_seen_hours: "Hace {{n}} h",
  devices_last_seen_days: "Hace {{n}} días",
  devices_revoke_success: "Sesión cerrada",
  devices_revoke_others_success: "{{n}} sesión(es) cerradas",
  devices_revoke_error: "No se pudo cerrar la sesión. Intenta de nuevo.",

  // Apariencia
  theme_label: "Tema",
  theme_light: "Claro",
  theme_dark: "Oscuro",
  appearance_theme_card_title: "Tema de la aplicación",
  appearance_theme_card_sub:
    "Afecta a colores de fondo, texto y superficies. El modo Sistema sigue la preferencia de tu dispositivo.",
  appearance_theme_light_hint: "Mejor para luz natural",
  appearance_theme_dark_hint: "Reduce fatiga visual",
  appearance_theme_system_label: "Sistema",
  appearance_theme_system_hint: "Sigue al sistema operativo",

  // Idioma & región
  language_eyebrow: "Localización",
  language_interface_label: "Idioma de la interfaz",
  language_interface_hint: "Aplica a menús, mensajes y comprobantes.",
  language_timezone_label: "Zona horaria",
  language_timezone_hint:
    "Usada en historial, reportes y notificaciones programadas. Se guarda en tu perfil.",
  language_timezone_save_success: "Zona horaria actualizada",
  language_country_label: "País",
  language_country_hint: "País de la cuenta.",
  language_country_save_success: "País actualizado",
  language_country_placeholder: "Selecciona un país",
  language_country_search_placeholder: "Buscar país…",
  language_country_no_results: "Sin resultados",

  // Seguridad - 2FA
  twofa_status_enabled: "ACTIVADO",
  twofa_status_disabled: "DESACTIVADO",
  twofa_enable_button: "Activar",
  twofa_disable_button: "Desactivar",
  twofa_description: "Autenticación de dos factores",
  security_2fa_title: "Verificación en dos pasos (2FA)",
  security_2fa_sub:
    "Se solicita en cada inicio de sesión y al confirmar envíos por encima del límite definido por tu organización.",
  security_2fa_status_not_configured: "SIN CONFIGURAR",
  security_2fa_protected_title: "Tu cuenta está protegida con 2FA",
  security_2fa_protected_sub: "Método principal: aplicación autenticadora (TOTP).",
  security_2fa_unprotected_title: "Tu cuenta no tiene 2FA",
  security_2fa_unprotected_sub: "Configúrala para cumplir con la política de seguridad de tu organización.",
  security_2fa_pick_method: "Elige un método principal",
  security_method_totp_name: "App autenticadora",
  security_method_totp_sub: "Google Authenticator, 1Password, Authy…",
  security_method_email_name: "Correo electrónico",
  security_method_email_sub: "Recibe un código de 6 dígitos en tu correo registrado.",
  security_method_tag_recommended: "RECOMENDADO",
  security_method_tag_coming_soon: "PRÓXIMAMENTE",
  security_2fa_totp_setup_title: "Vincular app autenticadora",
  security_2fa_totp_step: "PASO {{step}} DE {{total}}",
  security_2fa_code_valid_30s: "el código cambia cada 30 s",
  security_hide: "Ocultar",
  security_show: "Mostrar",
  security_recovery_title: "Códigos de respaldo",
  security_recovery_sub:
    "Guárdalos en un lugar seguro. Cada código solo puede usarse una vez si pierdes acceso a tu método principal.",
  security_recovery_regenerate: "Regenerar",
  security_recovery_download: "Descargar .txt",
  security_recovery_copy_all: "Copiar todos",
  security_recovery_copied: "Copiado",
  security_recovery_regenerated: "Nuevos códigos generados",
  security_recovery_warning_title: "Cópialos ahora: solo se muestran una vez",
  security_recovery_warning_body:
    "Al salir de esta página no podremos volver a mostrártelos. Guárdalos en tu gestor de contraseñas o donde prefieras.",
  security_recovery_empty_hint:
    "Tus códigos se generan automáticamente al activar 2FA. Si no los guardaste, regéneralos para obtener un set nuevo.",

  // Enable 2FA Modal
  enable_twofa_title: "Activar autenticación de dos factores",
  enable_twofa_scan_instructions:
    "Escanea este código QR con tu aplicación de autenticación (Google Authenticator, Authy, etc.)",
  enable_twofa_manual_entry: "O ingresa manualmente este código secreto:",
  enable_twofa_enter_code: "Ingresa el código de 6 dígitos de tu aplicación",
  enable_twofa_verify_button: "Verificar y activar",
  enable_twofa_cancel_button: "Cancelar",
  enable_twofa_success: "2FA activado exitosamente",

  // Disable 2FA Modal
  disable_twofa_title: "Desactivar autenticación de dos factores",
  disable_twofa_description: "Para desactivar 2FA, ingresa tu código actual de autenticación",
  disable_twofa_warning: "Advertencia: Esto reducirá la seguridad de tu cuenta",
  disable_twofa_verify_button: "Desactivar 2FA",
  disable_twofa_cancel_button: "Cancelar",
  disable_twofa_success: "2FA desactivado exitosamente",

  // Comunes
  copy_button: "Copiar",
  copied_message: "Copiado al portapapeles",
  copy_error_message: "No se pudo copiar al portapapeles",
  error_invalid_code: "Código inválido. Por favor intenta nuevamente.",
  error_generic: "Ocurrió un error. Por favor intenta más tarde.",

  // API Keys
  api_keys_empty: "Aún no hay API Keys creadas para esta organización.",
  api_keys_docs_button: "Documentación API",
  api_keys_enable_action: "Habilitar",
  api_keys_disable_action: "Deshabilitar",
  api_keys_edit_ips_button: "Editar IPs",
  api_keys_disable_title: "¿Desactivar esta API key?",
  api_keys_disable_subtitle: "Acción reversible — puedes reactivarla cuando quieras.",
  api_keys_disable_confirm: "Sí, desactivar",
  api_keys_disable_cancel: "Cancelar",
  api_keys_disable_success: "API Key desactivada",
  api_keys_enable_success: "API Key activada",
  api_keys_disable_impact_title: "Las integraciones que usen esta clave dejarán de funcionar",
  api_keys_disable_impact_unauthorized:
    "Todas las peticiones a la API con esta clave devolverán 401 Unauthorized.",
  api_keys_disable_impact_integrations:
    "Los servicios que dependan de ella (backend, jobs, etc.) se detendrán.",
  api_keys_disable_impact_reversible: "Puedes volver a activarla cuando quieras — no se borra ni rota.",
  api_keys_edit_ips_title: "IPs permitidas",
  api_keys_edit_ips_description:
    "Cuando hay IPs permitidas, las solicitudes desde otras direcciones se rechazan con",
  api_keys_edit_ips_placeholder: "54.213.10.45",
  api_keys_edit_ips_add: "Agregar",
  api_keys_edit_ips_remove: "Quitar",
  api_keys_edit_ips_save: "Guardar",
  api_keys_edit_ips_cancel: "Cancelar",
  api_keys_edit_ips_list_label: "IPs permitidas",
  api_keys_no_ips_hint: "Sin restricción de IP — la clave funciona desde cualquier dirección.",
  api_keys_invalid_ip: "Formato inválido. Usa una IPv4 (ej. 54.213.10.45) o CIDR (ej. 10.0.0.0/24).",
  api_keys_ip_duplicate: "Esa IP ya está en la lista.",
  api_keys_update_success: "API Key actualizada",
  api_keys_admin_no_ip_warning:
    "Esta es una clave ADMIN sin restricción de IP — se recomienda fuertemente acotarla a las IPs de tu backend de producción.",
  api_keys_add_ip_label: "Agregar IP o rango (CIDR)",
  api_keys_ip_label_placeholder: "Etiqueta (opcional)",
  api_keys_any_ip_pill: "Cualquier IP",
  api_keys_ip_entry_singular: "entrada",
  api_keys_ip_entry_plural: "entradas",
  api_keys_your_current_ip_is: "Tu IP actual es",
  api_keys_add_my_ip: "Añadir",
  api_keys_my_ip_label_default: "Mi IP actual",
  api_keys_ip_added: "Añadida",
  api_keys_my_ip_detecting: "Detectando tu IP actual…",
  api_keys_my_ip_unavailable:
    "No pudimos detectar tu IP actual automáticamente. Puedes escribirla manualmente arriba.",
  api_keys_create_button: "Crear API key",
  api_keys_create_title: "Crear API key",
  api_keys_create_name_label: "Nombre",
  api_keys_create_name_hint: "Para identificarla en logs y auditoría.",
  api_keys_create_name_placeholder: "Ej. Backend de producción",
  api_keys_create_scopes_label: "Permisos",
  api_keys_create_scopes_hint: "Selecciona solo lo mínimo necesario.",
  api_keys_create_scopes_selected: "{{count}} seleccionados",
  api_keys_create_quick_readonly: "Solo lectura",
  api_keys_create_quick_all: "Todo",
  api_keys_create_quick_none: "Ninguno",
  api_keys_create_group_select_all: "Todos",
  api_keys_create_group_clear: "Quitar",
  api_keys_create_advanced: "Configuración avanzada",
  api_keys_create_advanced_hint: "Restricciones de IP",
  api_keys_create_ip_section_label: "Restricción de IPs (allowlist)",
  api_keys_create_once_hint: "Verás la clave una sola vez tras crearla.",
  api_keys_create_submit: "Crear clave",
  api_keys_create_cancel: "Cancelar",
  api_keys_create_success: "API key creada.",
  api_keys_create_error: "No se pudo crear la API key.",
  api_keys_create_name_required: "Ingresa un nombre para la clave.",
  api_keys_create_scopes_required: "Selecciona al menos un permiso.",
  api_keys_created_banner_title: "Copia tu API key ahora",
  api_keys_created_banner_warning: "Por seguridad, esta clave se muestra una sola vez. No volverás a verla.",
  api_keys_created_copy: "Copiar",
  api_keys_created_copied: "Copiada",
  api_keys_created_dismiss: "Ya la guardé",
  api_keys_no_write_title: "La creación de API keys está restringida",
  api_keys_no_write_description:
    "Para habilitar la creación de claves necesitamos validar tu caso de uso. Escríbenos a {{email}} y lo activamos para tu organización.",
  api_keys_scope_group_identities: "Titulares",
  api_keys_scope_group_payments: "Pagos",
  api_keys_scope_group_wallets: "Billeteras",
  api_keys_scope_group_cards: "Tarjetas",
  api_keys_scope_group_webhooks: "Webhooks",
  api_keys_scope_identities_read: "Ver titulares",
  api_keys_scope_identities_write: "Crear y editar titulares",
  api_keys_scope_payments_read: "Ver pagos y cotizaciones",
  api_keys_scope_payments_write: "Crear cobros y pagos",
  api_keys_scope_wallets_read: "Ver saldos y movimientos",
  api_keys_scope_wallets_write: "Activar y administrar billeteras",
  api_keys_scope_cards_read: "Ver tarjetas",
  api_keys_scope_cards_write: "Crear y administrar tarjetas",
  api_keys_scope_cards_topup: "Recargar tarjetas",
  api_keys_scope_cards_transfer: "Transferir entre tarjetas",
  api_keys_scope_webhooks_read: "Ver la configuración y las entregas de webhooks",
  api_keys_scope_webhooks_write: "Configurar el endpoint de webhooks",
  relative_time_now: "ahora",
  relative_time_minutes: "hace {{n}} min",
  relative_time_hours: "hace {{n}} h",
  relative_time_days: "hace {{n}} d",

  // Access & permissions (RBAC)
  settings_group_access: "Acceso y permisos",
  access_users_nav_label: "Usuarios",
  access_eyebrow: "Acceso y permisos",
  access_users_title: "Usuarios",
  access_users_sub:
    "Personas del equipo. Cada una recibe roles que determinan su acceso efectivo, resuelto deny-first.",
  access_stat_active: "Activos",
  access_stat_no_roles: "Sin roles",
  access_search_person_placeholder: "Buscar persona o correo",
  access_filter_all_roles: "Todos los roles",
  access_stat_total: "Total",
  access_filter_all_statuses: "Todos los estados",
  access_status_active: "Activo",
  access_status_inactive: "Inactivo",
  access_status_suspended: "Suspendido",
  access_status_pending_verification: "Pendiente de verificación",
  access_role_filter_placeholder: "Filtrar por rol",
  access_search_min_hint: "Escribe al menos {{min}} caracteres para buscar",
  access_col_person: "Persona",
  access_col_roles: "Roles asignados",
  access_col_effective: "Acceso efectivo",
  access_col_actions: "Acciones",
  access_badge_you: "TÚ",
  access_badge_external: "EXT",
  access_badge_pending: "PENDIENTE",
  access_badge_no_roles: "SIN ROLES",
  access_badge_api_key: "API KEY",
  access_badge_roles_unavailable: "ROLES NO DISPONIBLES",
  access_roles_overflow_action: "Ver todos los roles ({{count}} más)",
  access_roles_overflow_more: "Roles adicionales: {{count}}",
  access_effective_unknown_title:
    "No se pudieron cargar los roles de esta entrada — el acceso efectivo es desconocido, no confirmado como sin acceso.",
  access_effective_catalog_unknown_title:
    "El catálogo de roles no está disponible — el acceso efectivo es desconocido, no confirmado como sin acceso.",
  access_catalog_unavailable:
    "No se pudo cargar el catálogo de roles (requiere el permiso roles:read). El acceso efectivo no puede calcularse y la gestión de roles está deshabilitada; los roles asignados se muestran solo a título informativo.",
  access_roles_partial_fail:
    "No se pudieron cargar los roles de {{count}} entradas. Su acceso se muestra como no disponible (desconocido), no como sin acceso.",
  access_action_roles: "Roles",
  access_action_view: "Ver",
  access_users_footnote:
    "El acceso efectivo es el resultado neto tras combinar todos los roles y resolver las políticas deny-first.",
  access_users_load_failed: "No se pudieron cargar los usuarios.",
  access_no_results: "Sin resultados.",
  access_no_access_title: "No tienes permisos para administrar el acceso",
  access_no_access_description:
    "Tu rol no incluye el permiso necesario. Pide a un administrador que te asigne acceso a usuarios y roles.",
  access_readonly_note: "Con tu rol puedes ver el acceso pero no modificarlo.",
  access_view_as_label: "Previsualizar como",
  access_view_as_editor: "Editor",
  access_view_as_viewer: "Solo lectura",
  access_view_as_demo: "DEMO · solo esta sesión",
  access_effective_granted_title: "permisos concedidos",
  access_effective_denied_title: "deny activos",

  // Access — invite person
  access_invite_action: "Invitar persona",
  access_invite_title: "Invitar persona",
  access_invite_sub:
    "La persona recibirá un correo con un enlace de un solo uso para crear su cuenta y unirse a tu organización.",
  access_invite_email_label: "Correo electrónico",
  access_invite_email_placeholder: "persona@empresa.com",
  access_invite_email_required: "El correo es obligatorio.",
  access_invite_email_invalid: "Ingresa un correo válido.",
  access_invite_field_max: "Máximo 255 caracteres.",
  access_invite_name_label: "Nombre (opcional)",
  access_invite_name_placeholder: "Nombre y apellido",
  access_invite_language_label: "Idioma de la invitación",
  access_invite_language_hint: "Idioma en el que se enviará el correo de invitación.",
  access_invite_cancel: "Cancelar",
  access_invite_submit: "Enviar invitación",
  access_invite_success: "Invitación enviada a {{email}}.",
  access_invite_roles_label: "Accesos con los que entra",
  access_invite_roles_hint:
    "Vienen marcados los permisos de solo lectura. Agrega los de escritura que necesite y se le asignan en el momento en que acepte.",
  access_invite_roles_search: "Buscar por nombre o identificador",
  access_invite_roles_clear: "Quitar todos",
  access_invite_roles_no_matches: "Ningún rol coincide con la búsqueda",
  access_invite_roles_global: "Global",
  access_invite_roles_none_selected: "Sin roles: entrará solo con lectura",
  access_invite_roles_count: "{{count}} roles seleccionados",
  access_invite_access_note_with_roles:
    "Al aceptar la invitación se le asignan los {{count}} roles seleccionados. Después puedes ajustarlos desde el catálogo de roles de esta misma sección.",
  access_invite_access_note:
    "La persona entrará con acceso de solo lectura. Cuando acepte la invitación aparecerá en esta tabla y podrás asignarle los roles que necesite.",

  // Access — API keys as principals
  access_apikeys_nav_label: "API Keys",
  access_apikeys_title: "API Keys",
  access_apikeys_sub:
    "Las claves de integración son principales igual que las personas: reciben los mismos roles y comparten el evaluador de permisos deny-first.",
  access_apikeys_stat_keys: "Claves",
  access_apikeys_truncated:
    "Mostrando las primeras {{shown}} de {{total}} claves. Usa la búsqueda para encontrar una clave específica; el conteo, el simulador y los miembros por rol reflejan solo las claves mostradas.",
  access_apikeys_search_placeholder: "Buscar clave",
  access_col_key: "Clave",
  access_apikeys_footnote:
    "Las API keys reciben roles igual que las personas; el acceso efectivo resulta de resolver sus políticas deny-first.",
  access_apikeys_admin_badge: "ADMIN",
  access_apikeys_super_badge: "SUPER",
  access_apikeys_inactive: "INACTIVA",
  access_apikeys_more_actions: "Más acciones",
  access_apikeys_ip_count_singular: "1 IP",
  access_apikeys_ip_count_plural: "{{count}} IPs",
  access_apikeys_any_ip: "cualquier IP",

  // Access — assignment drawer + auto-save + matrix
  access_drawer_apply_immediately: "Los cambios se guardan automáticamente.",
  access_drawer_readonly: "Solo lectura.",
  access_drawer_close: "Cerrar",
  access_drawer_roles_count: "Roles · {{count}} asignados",
  access_drawer_no_roles_available: "No hay roles disponibles.",
  access_drawer_search_roles_placeholder: "Buscar rol",
  access_drawer_no_role_matches: "Ningún rol coincide con la búsqueda.",
  access_drawer_group_broad: "Acceso amplio",
  access_drawer_group_org: "Roles de organización",
  access_drawer_group_empty: "Sin permisos",
  access_drawer_group_unknown: "Sin catalogar",
  access_drawer_deny_notice:
    "Hay {{count}} política(s) deny activas. Estas bloquean permisos aunque otro rol los conceda.",
  access_drawer_effective_title: "Acceso efectivo resultante",
  access_drawer_effective_hint: "* = deny gana sobre allow",
  access_drawer_no_roles_empty: "Sin roles — sin ningún acceso (deny por defecto).",
  access_saved_saving: "Guardando…",
  access_saved_done: "Cambios guardados automáticamente",
  access_saved_error: "No se pudieron guardar los cambios",

  // Access — friendly labels for the real catalog (backend Module)
  access_mod_users: "Usuarios",
  access_mod_api_key: "API keys",
  access_mod_roles: "Roles",
  access_mod_policies: "Políticas",
  access_mod_organizations: "Organizaciones",
  access_mod_organization_accounts: "Cuentas de organización",
  access_mod_identities: "Identidades (KYC)",
  access_mod_wallets: "Wallets",
  access_mod_wallets_transfer_sensitive: "Transferencia sensible de wallet",
  access_mod_cards: "Tarjetas",
  access_mod_cards_topup: "Recargas de tarjeta",
  access_mod_cards_transfer: "Transferencias de tarjeta",
  access_mod_cards_sensitive: "Datos sensibles de tarjeta",
  access_mod_cards_topup_sensitive: "Recarga sensible de tarjeta",
  access_mod_fees: "Comisiones",
  access_mod_fee_configurations: "Configuración de comisiones",
  access_mod_payments: "Motor de pagos",
  access_mod_payout_batches: "Pagos por lotes",
  access_mod_payout_batches_approve: "Aprobación de pagos por lotes",
  access_mod_clients: "Clientes",
  access_mod_client_accounts: "Cuentas de cliente",
  access_mod_operations: "Operaciones",
  access_mod_operations_payments: "Pagos / Dispersiones",
  access_mod_operations_confirmations: "Confirmaciones",
  access_mod_operations_notes: "Notas de operación",
  access_mod_operations_shipping_quotes: "Cotizaciones de envío",
  access_mod_operations_shipping_quotes_coloca: "Cotizaciones Coloca",
  access_mod_operations_audit: "Auditoría",
  access_mod_operations_public_accounts: "Cuentas públicas",
  access_mod_operations_notifications: "Notificaciones",

  // Access — Roles
  access_scope_global: "GLOBAL",
  access_scope_org: "ORG",
  access_roles_nav_label: "Roles",
  access_roles_title: "Roles",
  access_roles_sub:
    "Un rol agrupa políticas y se asigna a usuarios y API keys. Los roles globales los administra Coloca.",
  access_roles_create: "Crear rol",
  access_roles_group_global: "Roles globales",
  access_roles_group_global_note: "Gestionados por Coloca",
  access_roles_group_org: "Roles de la organización",
  access_roles_group_org_note: "Editables y eliminables",
  access_roles_group_org_empty: "Aún no has creado roles propios",
  access_roles_empty_group: "Sin roles aquí.",
  access_page_refresh: "Actualizar",
  access_page_clear_filters: "Limpiar filtros",
  access_page_scope_label: "Ámbito",
  access_page_scope_all: "Todos",
  access_page_col_actions: "Acciones",
  access_page_col_scope: "Ámbito",
  access_page_empty_filtered_body: "Prueba con otro término o cambia los filtros.",
  access_roles_search_placeholder: "Buscar por nombre, slug o descripción",
  access_roles_kpi_group_label: "Resumen del catálogo de roles",
  access_roles_kpi_total: "Roles",
  access_roles_kpi_deny: "Con deny",
  access_roles_kpi_deny_meta: "Quitan acceso",
  access_roles_kpi_no_policies: "Sin políticas",
  access_roles_kpi_no_policies_meta: "No conceden nada",
  access_roles_kpi_no_members: "Sin asignar",
  access_roles_col_role: "Rol",
  access_roles_col_policies: "Políticas",
  access_roles_col_reach: "Alcance",
  access_roles_col_members: "Asignaciones",
  access_roles_no_policies_badge: "Sin políticas",
  access_roles_empty_title: "Todavía no hay roles",
  access_roles_empty_body: "Crea el primero para empezar a agrupar políticas y poder asignarlas.",
  access_roles_empty_filtered_title: "Ningún rol coincide",
  access_roles_protected_hint: "Rol del sistema, de solo lectura",
  access_roles_readonly_note: "Puedes consultar el catálogo, pero no crear ni modificar roles.",
  access_policies_search_placeholder: "Buscar por nombre, descripción o permiso (recurso:acción)",
  access_policies_kpi_group_label: "Resumen del catálogo de políticas",
  access_policies_kpi_total: "Políticas",
  access_policies_kpi_allow: "Allow",
  access_policies_kpi_deny: "Deny",
  access_policies_kpi_deny_meta: "Ganan sobre cualquier allow",
  access_policies_kpi_unused: "Sin usar",
  access_policies_kpi_unused_meta: "Ningún rol las enlaza",
  access_policies_col_policy: "Política",
  access_policies_col_effect: "Efecto",
  access_policies_col_permissions: "Permisos",
  access_policies_col_used_by: "Usada por",
  access_policies_unused_badge: "Sin usar",
  access_policies_usage_unknown_title:
    "No pudimos leer el catálogo de roles, así que no sabemos si algún rol la enlaza.",
  access_policies_usage_unknown_meta: "Desconocido",
  access_policies_usage_unavailable:
    "Sin acceso al catálogo de roles no podemos saber qué políticas están enlazadas, así que la opción de eliminar no está disponible.",
  access_policies_empty_title: "Todavía no hay políticas",
  access_policies_empty_body: "Crea la primera para agrupar permisos y poder enlazarlos a un rol.",
  access_policies_empty_filtered_title: "Ninguna política coincide",
  access_policies_protected_hint: "Política del sistema, de solo lectura",
  access_policies_readonly_note: "Puedes consultar el catálogo, pero no crear ni modificar políticas.",
  access_apikeys_kpi_group_label: "Resumen del catálogo de claves",
  access_apikeys_kpi_total: "Claves",
  access_apikeys_kpi_active: "Activas",
  access_apikeys_kpi_no_roles: "Sin roles",
  access_apikeys_kpi_no_roles_meta: "No autorizan nada",
  access_apikeys_kpi_no_roles_partial: "Mínimo: faltan roles por leer",
  access_apikeys_kpi_not_active: "Inactivas o expiradas",
  access_apikeys_col_organization: "Organización",
  access_apikeys_col_status: "Estado",
  access_apikeys_status_active: "Activa",
  access_apikeys_status_expired: "Expirada",
  access_apikeys_status_inactive: "Inactiva",
  access_apikeys_org_global: "Global",
  access_apikeys_truncated_page:
    "Mostrando las primeras {{shown}} de {{total}} claves. La búsqueda, los filtros y los indicadores de esta página describen solo las claves cargadas.",
  access_apikeys_empty_title: "Todavía no hay claves de API",
  access_apikeys_empty_body: "Crea la primera para que una integración pueda autenticarse.",
  access_apikeys_empty_filtered_title: "Ninguna clave coincide",
  access_apikeys_empty_filtered_body: "Prueba con otro término o cambia el filtro de rol.",
  access_role_default_badge: "DEFAULT",
  access_role_policy_count_singular: "1 política",
  access_role_policy_count_plural: "{{count}} políticas",
  access_role_has_deny: "con deny",
  access_role_editor_new: "Crear rol",
  access_role_editor_new_sub: "Define un rol propio agrupando políticas.",
  access_role_editor_edit: "Editar rol",
  access_role_editor_view: "Ver rol",
  access_role_name_label: "Nombre del rol",
  access_role_name_placeholder: "Ej. Aprobador de pagos",
  access_role_name_required: "Ingresa un nombre para el rol.",
  access_role_desc_label: "Descripción",
  access_role_desc_placeholder: "Para qué sirve este rol.",
  access_role_policies_label: "Políticas del rol",
  access_role_policies_allow: "Permitir (allow)",
  access_role_policies_deny: "Denegar (deny)",
  access_role_policies_deny_hint: "Estas ganan sobre cualquier allow del rol.",
  access_role_policies_none_available: "Ninguna disponible.",
  access_role_effective_title: "Acceso efectivo resultante",
  access_role_no_policies_empty: "Sin políticas — sin ningún acceso (deny por defecto).",
  access_role_readonly_note: "Rol global o protegido gestionado por Coloca · solo lectura.",
  access_role_save: "Guardar",
  access_role_create_action: "Crear rol",
  access_role_cancel: "Cancelar",
  access_role_delete: "Eliminar",
  access_role_delete_title: "¿Eliminar rol?",
  access_role_delete_desc:
    "El rol «{{name}}» se quitará de cualquier usuario o API key que lo use. Esta acción no se puede deshacer.",
  access_role_delete_confirm: "Eliminar rol",
  access_role_created: "Rol creado.",
  access_role_updated: "Rol actualizado.",
  access_role_deleted: "Rol eliminado.",
  access_role_member_count_platform_one: "1 en la plataforma",
  access_role_member_count_platform: "{{count}} en la plataforma",
  access_role_member_count_org_one: "1 en tu organización",
  access_role_member_count_org: "{{count}} en tu organización",
  access_role_members_users_label: "Usuarios con este rol",
  access_role_members_keys_note:
    "Además hay API keys con este rol; no se pueden listar por rol, pero cuentan en el total.",
  access_role_members_unavailable: "No se pudo cargar la lista de usuarios.",
  access_role_members_label: "Principales que usan este rol",
  access_role_no_members: "Ningún principal usa este rol todavía.",
  access_role_members_more: "+{{count}} más",
  access_role_delete_desc_members:
    "El rol «{{name}}» se quitará de {{count}} principal(es) que lo usan. Esta acción no se puede deshacer.",

  // Access — editor validation (shared by role + policy editors; limits mirror the backend DTOs)
  access_validation_name_max: "Máximo 120 caracteres.",
  access_validation_desc_max: "Máximo 500 caracteres.",

  // Access — Policies
  access_policy_effect_allow: "ALLOW",
  access_policy_effect_deny: "DENY",
  access_policies_nav_label: "Políticas",
  access_policies_title: "Políticas",
  access_policies_sub:
    "Una política agrupa permisos recurso:acción bajo un solo efecto. Las políticas deny ganan siempre sobre las allow.",
  access_policies_create: "Nueva política",
  access_policies_group_allow: "Permitir (allow)",
  access_policies_group_allow_note: "Conceden acceso a recursos.",
  access_policies_group_deny: "Denegar (deny)",
  access_policies_group_deny_note: "Bloquean acceso aunque otra lo conceda.",
  access_policies_empty_group: "Sin políticas en este grupo.",
  access_policy_stmt_summary: "{{permits}} permisos · {{resources}} recursos",
  access_policy_used_by_singular: "usada por 1 rol",
  access_policy_used_by_plural: "usada por {{count}} roles",
  access_policy_editor_new: "Nueva política",
  access_policy_editor_new_sub: "Define un bloque de permisos reutilizable.",
  access_policy_editor_edit: "Editar política",
  access_policy_editor_view: "Ver política",
  access_policy_name_label: "Nombre",
  access_policy_name_placeholder: "Ej. Pagos · Operación",
  access_policy_name_required: "Ingresa un nombre para la política.",
  access_policy_name_taken: "Ya existe una política con ese nombre.",
  access_policy_desc_label: "Descripción",
  access_policy_desc_placeholder: "Qué concede o niega esta política.",
  access_policy_effect_label: "Efecto",
  access_policy_effect_allow_title: "Permitir",
  access_policy_effect_allow_hint: "Concede acceso",
  access_policy_effect_deny_title: "Denegar",
  access_policy_effect_deny_hint: "Bloquea — gana sobre allow",
  access_policy_statements_label: "Permisos de esta política",
  access_policy_statements_hint: "recurso : acción",
  access_policy_statements_required: "Selecciona al menos un permiso.",
  access_policy_permits_singular: "1 permiso",
  access_policy_permits_plural: "{{count}} permisos",
  access_policy_readonly_note: "Política global o protegida gestionada por Coloca · solo lectura.",
  access_policy_save: "Guardar",
  access_policy_create_action: "Crear política",
  access_policy_cancel: "Cancelar",
  access_policy_delete: "Eliminar",
  access_policy_delete_disabled_hint: "Quítala de los roles antes de eliminar.",
  access_policy_delete_title: "¿Eliminar política?",
  access_policy_delete_desc: "La política «{{name}}» se eliminará. Esta acción no se puede deshacer.",
  access_policy_delete_confirm: "Eliminar política",
  access_policy_delete_in_use:
    "No se puede eliminar: la política está en uso por uno o más roles. Quítala de ellos primero.",
  access_policy_created: "Política creada.",
  access_policy_updated: "Política actualizada.",
  access_policy_deleted: "Política eliminada.",

  // Access — Simulator
  access_sim_nav_label: "Simulador",
  access_sim_title: "Simulador de acceso",
  access_sim_sub:
    "Comprueba por qué un principal puede o no ejecutar una acción — qué rol y política la conceden, y si un deny la está anulando.",
  access_sim_principal_label: "Principal",
  access_sim_principal_placeholder: "Selecciona un principal",
  access_sim_no_principals: "No hay principales (usuarios o API keys) para simular.",
  access_sim_page_scope_note:
    "Puedes simular sobre los {{count}} principales de la página actual de Usuarios y las API keys cargadas. Filtra o pagina esa tabla para alcanzar a otros.",
  access_sim_selection_dropped:
    "El principal que estabas simulando ya no está en la página actual. Vuelve a elegirlo o ajusta los filtros de Usuarios.",
  access_sim_partial_principals:
    "{{count}} entradas se excluyeron del simulador porque sus roles no se pudieron cargar.",
  access_sim_matrix_hint: "Haz clic en un permiso para inspeccionarlo",
  access_sim_pick_prompt: "Selecciona un permiso en la matriz para ver cómo se resuelve.",
  access_sim_explanation_title: "Explicación",
  access_sim_result_allow: "PERMITIDO",
  access_sim_result_deny: "DENEGADO",
  access_sim_result_none: "DENEGADO (por defecto)",
  access_sim_reason_allowed_by: "Permitido por",
  access_sim_reason_denied_by: "Denegado por",
  access_sim_reason_overridden: "Allow anulado (no surte efecto)",
  access_sim_summary_allow: "concedido por política allow",
  access_sim_summary_deny: "bloqueado por política deny",
  access_sim_summary_deny_wins: "deny gana sobre {{count}} allow",
  access_sim_summary_none: "ningún allow coincide",
  access_sim_none_detail:
    "Ninguna política asignada a {{name}} concede {{perm}}. Por la regla default-deny, sin un allow explícito el acceso se niega.",
  access_sim_rule:
    "Regla: primero gana cualquier deny; si no hay deny, basta un allow; si no hay ninguno, se niega por defecto.",
  access_sim_via_policy: "política {{policy}}",
  access_mod_organization_webhooks: "Webhooks",

  // Webhooks (salientes, grupo Desarrolladores)
  webhooks_nav_label: "Webhooks",
  webhooks_section_eyebrow: "Desarrolladores",
  webhooks_section_title: "Webhooks salientes",
  webhooks_section_sub:
    "Coloca avisa a tu servidor cada vez que cambia el estado de un payin, un payout o un swap. Un solo endpoint HTTPS recibe todos los eventos.",
  webhooks_load_error: "No pudimos cargar la configuración de webhooks.",
  webhooks_retry_load: "Reintentar",
  webhooks_empty_title: "Todavía no recibes eventos",
  webhooks_empty_desc:
    "Registra la URL HTTPS de tu servidor. Cada entrega llega con la cabecera x-secret para que compruebes que viene de Coloca.",
  webhooks_add_endpoint: "Agregar endpoint",
  webhooks_endpoint_label: "Endpoint",
  webhooks_secret_label: "Secreto",
  webhooks_secret_header_hint: "Va en la cabecera {{header}} de cada entrega",
  webhooks_status_active: "Activo",
  webhooks_status_paused: "Pausado",
  webhooks_status_auto_disabled: "Desactivado por fallas",
  webhooks_disabled_reason_streak:
    "Pausamos las entregas tras 50 fallas consecutivas de tu servidor. Corrígelo, prueba la conexión y vuelve a activar el endpoint.",
  webhooks_disabled_reason_prolonged:
    "Pausamos las entregas tras 24 horas sin una respuesta exitosa de tu servidor. Corrígelo, prueba la conexión y vuelve a activar el endpoint.",
  webhooks_paused_hint:
    "Mientras esté pausado no encolamos entregas nuevas. La prueba de conexión sigue funcionando para que verifiques el arreglo.",
  webhooks_health_failures: "Fallas seguidas",
  webhooks_health_last_success: "Último éxito",
  webhooks_health_last_failure: "Última falla",
  webhooks_health_never: "Nunca",
  webhooks_toggle_aria: "Activar o pausar las entregas",
  webhooks_action_edit_url: "Cambiar URL",
  webhooks_action_test: "Enviar evento de prueba",
  webhooks_action_rotate: "Rotar secreto",
  webhooks_action_delete: "Eliminar endpoint",
  webhooks_toast_saved: "Endpoint guardado",
  webhooks_toast_paused: "Entregas pausadas",
  webhooks_toast_resumed: "Entregas reanudadas",
  webhooks_toast_rotated: "Secreto rotado",
  webhooks_toast_deleted: "Endpoint eliminado",
  webhooks_toast_resend_queued: "Reenvío encolado como una entrega nueva",
  webhooks_toast_retry_queued: "Entrega reencolada",
  webhooks_error_no_write_permission: "Tu rol no puede modificar la configuración de webhooks.",
  webhooks_read_only_notice:
    "Tu rol solo permite ver los webhooks. Para configurarlos, pide a un administrador de tu organización que te asigne el rol de escritura de webhooks en Ajustes → Usuarios.",
  webhooks_url_dialog_title_create: "Agregar endpoint",
  webhooks_url_dialog_title_edit: "Cambiar la URL del endpoint",
  webhooks_url_dialog_desc:
    "Debe ser HTTPS y responder 2xx en menos de 10 segundos. Si falla, reintentamos hasta 5 veces con esperas crecientes.",
  webhooks_url_field_label: "URL de tu servidor",
  webhooks_url_field_placeholder: "https://api.tuempresa.com/coloca/webhooks",
  webhooks_url_invalid: "Ingresa una URL HTTPS válida.",
  webhooks_url_save: "Guardar endpoint",
  webhooks_url_register_and_verify: "Registrar y verificar",
  webhooks_url_cancel: "Cancelar",
  webhooks_secret_field_label: "Secreto compartido",
  webhooks_secret_field_hint_create:
    "Lo enviamos en la cabecera {{header}} de cada evento. Usa el que ya espera tu servidor, o déjalo vacío y lo generamos.",
  webhooks_secret_field_hint_edit:
    "Déjalo vacío para conservar el secreto actual. Si escribes uno nuevo, empieza a viajar en {{header}} de inmediato.",
  webhooks_secret_field_placeholder: "Mínimo 16 caracteres, sin espacios",
  webhooks_secret_generate: "Generar uno",
  webhooks_secret_invalid: "Usa al menos {{min}} caracteres imprimibles, sin espacios.",
  webhooks_handshake_explainer:
    "Al registrar enviamos un saludo de configuración a tu servidor. Si responde 2xx activamos las entregas; si no, el endpoint queda pausado y te mostramos qué contestó.",
  webhooks_toast_saved_paused: "Endpoint guardado y pausado",
  webhooks_toast_handshake_ok: "Tu servidor respondió: entregas activadas",
  webhooks_toast_handshake_failed: "Endpoint guardado en pausa: tu servidor no aceptó el saludo",
  webhooks_secret_banner_title: "Guarda este secreto ahora",
  webhooks_secret_banner_warning:
    "Solo se muestra una vez. Compáralo con la cabecera {{header}} de cada entrega para confirmar que viene de Coloca.",
  webhooks_secret_copy: "Copiar",
  webhooks_secret_copied: "Copiado",
  webhooks_secret_dismiss: "Ya lo guardé",
  webhooks_secret_reveal: "Revelar",
  webhooks_secret_hide: "Ocultar",
  webhooks_error_no_reveal_permission: "Tu rol no puede ver el secreto completo.",
  webhooks_rotate_title: "¿Rotar el secreto?",
  webhooks_rotate_desc:
    "Las entregas usan el secreto nuevo de inmediato. Actualiza tu servidor en la misma ventana o rechazará los eventos.",
  webhooks_rotate_confirm: "Rotar secreto",
  webhooks_delete_title: "¿Eliminar el endpoint?",
  webhooks_delete_desc:
    "Dejamos de enviar eventos. El historial de entregas se conserva y puedes registrar otro endpoint cuando quieras.",
  webhooks_delete_confirm: "Eliminar endpoint",
  webhooks_handshake_verified_title: "Endpoint verificado en {{ms}} ms",
  webhooks_handshake_verified_detail:
    "Tu servidor devolvió el secreto correcto, así que confirmamos que es tuyo. Ya puede recibir eventos.",
  webhooks_handshake_no_response_title: "Tu servidor no respondió",
  webhooks_handshake_no_response_detail:
    "No obtuvimos ninguna respuesta: {{error}}. Revisa que la URL sea alcanzable desde internet, que el certificado sea válido y que responda en menos de 10 segundos.",
  webhooks_handshake_http_error_title: "Tu servidor rechazó el evento",
  webhooks_handshake_http_error_detail:
    "Respondió HTTP {{status}} en {{ms}} ms. Necesitamos un 2xx para considerar el endpoint verificado.",
  webhooks_handshake_invalid_response_title: "La respuesta no es JSON",
  webhooks_handshake_invalid_response_detail:
    "Tu servidor respondió correctamente, pero el cuerpo no es un objeto JSON. Devuelve el valor de la cabecera {{header}} en un campo llamado secret:",
  webhooks_handshake_secret_missing_title: "Falta el secreto en la respuesta",
  webhooks_handshake_secret_missing_detail:
    "Tu servidor respondió 200 pero sin devolver el secreto, y sin eso cualquier URL que responda pasaría la prueba. Devuelve el valor de la cabecera {{header}} en un campo llamado secret:",
  webhooks_handshake_secret_mismatch_title: "El secreto no coincide",
  webhooks_handshake_secret_mismatch_detail:
    "Tu servidor devolvió un secreto distinto al configurado. Compara el valor con la cabecera {{header}} de la petición que acabas de recibir, o rota el secreto si el tuyo quedó desactualizado:",
  webhooks_test_hint: "La prueba quedó registrada en el reporte de entregas como Prueba · Ping.",
  webhooks_no_response: "sin respuesta",
  webhooks_deliveries_title: "Entregas",
  webhooks_deliveries_sub:
    "Cada intento con su código HTTP y su latencia. Reintenta las que fallaron cuando tu servidor esté listo.",
  webhooks_deliveries_refresh: "Actualizar",
  webhooks_deliveries_error: "No pudimos cargar las entregas.",
  webhooks_deliveries_empty_title: "Sin entregas todavía",
  webhooks_deliveries_empty_desc:
    "Aparecerán aquí cuando ocurra algo en tus pagos, identidades, tarjetas o billeteras, o cuando envíes un evento de prueba.",
  webhooks_deliveries_empty_filtered: "Ninguna entrega coincide con los filtros",
  webhooks_filter_status: "Estado",
  webhooks_filter_type: "Tipo",
  webhooks_filter_event: "Evento",
  webhooks_filter_status_code: "Código HTTP",
  webhooks_filter_range: "Fechas",
  webhooks_filter_all: "Todos",
  webhooks_filter_apply: "Aplicar filtros",
  webhooks_filter_clear: "Limpiar filtros",
  webhooks_th_created: "Fecha",
  webhooks_th_event: "Evento",
  webhooks_th_status: "Estado",
  webhooks_th_http: "HTTP",
  webhooks_th_attempts: "Intentos",
  webhooks_th_latency: "Latencia",
  webhooks_status_pending: "En curso",
  webhooks_status_delivered: "Entregado",
  webhooks_status_failed: "Rechazado",
  webhooks_status_exhausted: "Sin reintentos",
  webhooks_type_payments: "Pagos",
  webhooks_type_identities: "Identidades",
  webhooks_type_cards: "Tarjetas",
  webhooks_type_wallets: "Billeteras",
  webhooks_type_test: "Prueba",
  webhooks_event_payin_created: "Payin creado",
  webhooks_event_payin_pending: "Payin pendiente",
  webhooks_event_payin_approved: "Payin aprobado",
  webhooks_event_payin_confirmed: "Payin confirmado",
  webhooks_event_payin_settled: "Payin liquidado",
  webhooks_event_payin_rejected: "Payin rechazado",
  webhooks_event_payin_reversed: "Payin reversado",
  webhooks_event_payout_created: "Payout creado",
  webhooks_event_payout_processing: "Payout en proceso",
  webhooks_event_payout_paid: "Payout pagado",
  webhooks_event_payout_failed: "Payout fallido",
  webhooks_event_payout_cancelled: "Payout cancelado",
  webhooks_event_payout_reversed: "Payout reversado",
  webhooks_event_swap_completed: "Swap completado",
  webhooks_event_identity_created: "Identidad creada",
  webhooks_event_kyc_approved: "Verificación aprobada",
  webhooks_event_kyc_rejected: "Verificación rechazada",
  webhooks_event_cardholder_created: "Tarjetahabiente creado",
  webhooks_event_card_created: "Tarjeta creada",
  webhooks_event_card_status_changed: "Cambió el estado de la tarjeta",
  webhooks_event_card_transaction_authorized: "Transacción de tarjeta autorizada",
  webhooks_event_card_transaction_declined: "Transacción de tarjeta rechazada",
  webhooks_event_card_transaction_refunded: "Transacción de tarjeta reembolsada",
  webhooks_event_card_transaction_reversed: "Transacción de tarjeta reversada",
  webhooks_event_card_topped_up: "Tarjeta recargada",
  webhooks_event_card_deposit_received: "Depósito cripto recibido",
  webhooks_event_card_withdrawn: "Retiro de la tarjeta",
  webhooks_event_card_wallet_recharged: "Billetera de tarjetas recargada",
  webhooks_event_wallet_created: "Billetera creada",
  webhooks_event_ping: "Ping",
  webhooks_endpoint_disabled_error: "El endpoint estaba pausado o eliminado al momento del intento",
  webhooks_drawer_title: "Detalle de la entrega",
  webhooks_drawer_id: "ID de entrega",
  webhooks_drawer_event_id: "ID del recurso",
  webhooks_drawer_url: "Enviado a",
  webhooks_drawer_created: "Creada",
  webhooks_drawer_delivered: "Entregada",
  webhooks_drawer_last_error: "Último error",
  webhooks_drawer_payload: "Cuerpo enviado",
  webhooks_drawer_response: "Respuesta de tu servidor",
  webhooks_drawer_response_truncated: "Guardamos los primeros 2 KB de la respuesta.",
  webhooks_drawer_response_empty: "Sin cuerpo de respuesta",
  webhooks_drawer_retry: "Reintentar entrega",
  webhooks_drawer_resend: "Reenviar entrega",
  webhooks_drawer_resend_hint:
    "Esta entrega ya llegó. Reenviarla crea una entrega nueva con otro id de evento, así que tu servidor la va a procesar por segunda vez.",
  webhooks_drawer_retry_hint:
    "Esta entrega todavía se está intentando. Espera a que termine para poder reencolarla.",
  webhooks_guide_title: "Cómo conectar tu servidor",
  webhooks_guide_sub:
    "Cómo configurar el secreto, qué eventos enviamos, el contrato del handshake y qué pasa al rotar o cambiar la URL",
  webhooks_guide_setup_title: "Guarda el secreto en tu servidor",
  webhooks_guide_setup_body:
    "El handshake corre en el momento en que registras la URL, así que el secreto tiene que estar guardado en tu servidor antes de registrarla. Si no, la primera verificación falla y el endpoint queda pausado.",
  webhooks_guide_setup_own:
    "Trae tu propio secreto (recomendado): pega en el campo Secreto compartido del formulario el mismo valor que ya tiene tu servidor. Así el endpoint se activa al primer intento.",
  webhooks_guide_setup_generated:
    "O deja que lo generemos nosotros: cópialo del banner —se muestra una sola vez—, guárdalo en tu servidor, envía un evento de prueba y activa el endpoint.",
  webhooks_guide_setup_format:
    "Formato: de 16 a 255 caracteres ASCII imprimibles, sin espacios. Guárdalo como variable de entorno o secreto, nunca en el código.",
  webhooks_guide_receive_title: "Recibe el evento",
  webhooks_guide_receive_body:
    "Enviamos un POST con un cuerpo JSON siempre de la misma forma: enruta por type (el grupo) y event (lo que pasó); data es el recurso tal como lo devuelve su endpoint público GET /:id. El secreto viaja en la cabecera {{header}} en todas las entregas, no solo en la prueba.",
  webhooks_guide_receive_dedupe:
    "Deduplica por id: se mantiene igual en todos los reintentos de una entrega. Reenviar desde aquí un evento ya entregado genera un id nuevo.",
  webhooks_guide_receive_snapshot:
    "data es una foto del momento del evento. Si necesitas el recurso como está ahora, vuelve a leerlo con GET.",
  webhooks_guide_receive_order:
    "Los eventos pueden llegar en desorden: compara created_at y acepta un evento sobre un recurso que aún no conoces.",
  webhooks_guide_handshake_title: "Devuelve el secreto en el evento de prueba",
  webhooks_guide_handshake_body:
    "Cuando llega type test con event ping, responde 200 con un JSON que traiga de vuelta el valor de la cabecera {{header}} en un campo llamado secret. Sin ese eco no activamos el endpoint: un 200 lo devuelve cualquier URL, y eso no prueba que seas tú quien escucha. Los demás eventos solo necesitan un 2xx.",
  webhooks_guide_verify_title: "Valida el secreto en cada request",
  webhooks_guide_verify_body:
    "De tu lado, compara la cabecera {{header}} con el secreto que guardaste y rechaza con 401 si no coincide, antes de procesar nada. Esa comparación es lo que impide que un tercero te inyecte eventos falsos.",
  webhooks_guide_catalog_title: "Eventos que enviamos",
  webhooks_guide_catalog_body: "Elige un grupo para ver sus eventos y un ejemplo del cuerpo que recibes.",
  webhooks_guide_catalog_kyb:
    "kyc_approved y kyc_rejected también cubren la verificación de empresas (KYB): distínguelas con data.type.",
  webhooks_guide_catalog_events: "Eventos",
  webhooks_guide_catalog_example: "Ejemplo",
  webhooks_guide_rotation_title: "Rotar el secreto y cambiar la URL",
  webhooks_guide_rotation_badge: "Pausa las entregas",
  webhooks_guide_rotation_rotate:
    "Al rotar, el endpoint queda pausado de inmediato y repetimos el handshake. Si tu servidor sigue respondiendo el secreto anterior, queda inhabilitado hasta que lo actualices.",
  webhooks_guide_rotation_url:
    "Al cambiar la URL pasa lo mismo: se guarda pausado, corremos el handshake contra la dirección nueva y solo entonces se reactiva.",
  webhooks_guide_rotation_activate:
    "Activar el switch también exige el handshake. Si tu servidor no devuelve el secreto, la activación se rechaza y el endpoint no cambia.",
  webhooks_guide_rotation_order:
    "Por eso el orden importa: actualiza primero el secreto en tu servidor y después envía un evento de prueba desde aquí.",
  webhooks_guide_retries_title: "Reintentos y fallas",
  webhooks_guide_retries_body:
    "Damos 10 segundos por intento. Un 5xx, un 408, un 429 o un timeout se reintentan hasta 5 veces con esperas crecientes de 1, 2, 4 y 8 minutos. Cualquier otro 4xx se considera un rechazo definitivo y no se reintenta. Si tu endpoint acumula fallas te avisamos por correo y, si sigue caído, lo pausamos solos.",
  webhooks_activate_blocked:
    "Envía un evento de prueba y verifica el handshake antes de activar el endpoint.",
  webhooks_disabled_reason_handshake:
    "Pausamos las entregas porque tu servidor no devolvió el secreto correcto tras el último cambio. Actualízalo, envía un evento de prueba y vuelve a activarlo.",
  webhooks_toast_rotated_paused:
    "Secreto rotado y entregas en pausa: actualiza tu servidor y vuelve a activar el endpoint",
  webhooks_toast_saved_revalidation_failed:
    "Endpoint guardado y pausado: tu servidor no devolvió el secreto tras el cambio",
  webhooks_copy_aria: "Copiar",
  webhooks_copy_success: "Copiado al portapapeles",

  // Account → Verification
  verification_nav_label: "Verificación",
  card_wallet_nav_label: "Wallet de tarjetas",
  card_wallet_section_eyebrow: "Tarjetas",
  card_wallet_section_title: "Wallet de tarjetas",
  card_wallet_section_sub:
    "Un saldo en dólares de tu organización que conecta tus tarjetas: se cargan desde ahí y lo que retiras de ellas vuelve ahí.",
  card_wallet_status_on: "Activa",
  card_wallet_status_off: "No activa",
  card_wallet_compare_without: "Sin la wallet",
  card_wallet_compare_with: "Con la wallet",
  card_wallet_row_load: "Cargar tarjetas",
  card_wallet_row_load_without: "Desde pesos o enviando cripto",
  card_wallet_row_load_with: "También desde la wallet, al instante",
  card_wallet_row_withdraw: "Retirar saldo de una tarjeta",
  card_wallet_row_withdraw_without: "No se puede: solo moverlo a otra tarjeta",
  card_wallet_row_withdraw_with: "Sí: vuelve a la wallet",
  card_wallet_activate: "Conocer y activar",
  card_wallet_permanent_note: "Una vez activa, solo el equipo de soporte puede desactivarla.",
  card_wallet_on_body:
    "Tus tarjetas se cargan desde la wallet al instante, y lo que retiras de ellas vuelve ahí.",
  card_wallet_go_to_cards: "Ver en Tarjetas",
  card_wallet_on_note: "Para desactivarla, escríbele al equipo de soporte.",
  verification_section_title: "Verificación de la cuenta",
  verification_section_sub:
    "Tu verificación KYC o KYB define qué operaciones puedes hacer. Aquí puedes iniciarla, retomarla y ver lo que enviaste.",
  verification_empty_title: "Aún no has verificado tu cuenta",
  verification_empty_description:
    "Elige si operas como persona natural (KYC) o como empresa (KYB) y completa la verificación para habilitar todas las operaciones.",
  verification_type_label: "Tipo de verificación",
  verification_type_person: "Persona natural (KYC)",
  verification_type_business: "Empresa (KYB)",
  verification_status_label: "Estado",
  verification_verified_at: "Aprobada el {{date}}",
  verification_pending_hint: "Aún no la has completado. Retómala donde la dejaste.",
  verification_in_review_hint: "En revisión. Te avisaremos por correo cuando tengamos el resultado.",
  verification_expired_hint: "La verificación expiró. Vuelve a iniciarla para seguir operando.",
  verification_copy_link: "Copiar enlace de verificación",
  verification_copy_link_hint:
    "Envíaselo a quien complete la verificación, por ejemplo el representante legal.",
  verification_data_title: "Datos enviados",
  verification_data_note:
    "Estos son los datos que validó la verificación. Para corregirlos, escribe a soporte.",
  verification_field_name: "Nombre",
  verification_field_legal_name: "Razón social",
  verification_field_document: "Documento",
  verification_field_tax_id: "Identificación fiscal",
  verification_field_country: "País",
  verification_field_birthdate: "Fecha de nacimiento",
  verification_field_nationality: "Nacionalidad",
  verification_field_business_type: "Tipo de empresa",
  verification_field_incorporation_date: "Fecha de constitución",
  verification_field_representative: "Representante legal",
  verification_field_representative_document: "Documento del representante",
  verification_field_address: "Dirección",
  verification_field_representative_address: "Dirección del representante",
  verification_capabilities_title: "Qué puedes hacer",
  verification_change_title: "Cambiar identidad",
  verification_change_hint:
    "Verifica la cuenta con otra persona o empresa, o pasa de persona natural a empresa y viceversa.",
  verification_change_identity: "Verificar con otra identidad",
  verification_change_dialog_title: "¿Verificar con otra identidad?",
  verification_change_dialog_description:
    "La verificación actual dejará de aplicar a tu cuenta y no podrás enviar dinero hasta que la nueva verificación esté aprobada. Podrás elegir de nuevo entre persona natural y empresa.",
  verification_change_dialog_confirm: "Sí, usar otra identidad",
  verification_change_dialog_cancel: "Cancelar",
  verification_change_cooldown_hint:
    "Cambiaste una identidad verificada hace poco. Disponible de nuevo a partir del {{date}}.",
  verification_change_request: "Solicitar cambio anticipado",
  verification_change_request_sent: "Solicitud enviada. Operaciones revisará tu caso.",
  verification_error_load: "No pudimos cargar el estado de tu verificación.",
  verification_retry: "Reintentar",
  verification_data_unavailable: "No pudimos cargar los datos de la verificación. Inténtalo más tarde.",
  verification_copy_link_unavailable:
    "Se generó un nuevo enlace, pero no pudimos copiarlo al portapapeles. Vuelve a intentarlo desde un navegador compatible.",
  security_pin_status_badge: "PIN ACTIVO",
  security_pin_active_title: "Tu cuenta está protegida con un PIN de seguridad",
  security_pin_active_sub:
    "Te lo pediremos para acciones sensibles. Para más seguridad, pásate a la app autenticadora.",
  security_pin_change: "Cambiar PIN",
  security_pin_remove: "Quitar PIN",
  security_pin_locked_title: "Tu PIN está bloqueado",
  security_pin_locked_temporary:
    "Demasiados intentos fallidos. Se desbloquea en {{time}}, o crea uno nuevo ahora.",
  security_pin_locked_reset:
    "Demasiados intentos fallidos. Crea un PIN nuevo con tu contraseña para seguir usándolo.",
  security_pin_locked_action: "Crear PIN nuevo",
  security_totp_replaces_pin:
    "La app autenticadora protege tus acciones sensibles y reemplaza al PIN de seguridad.",
  security_totp_will_replace_pin:
    "Cuando verifiques el código, la app reemplaza a tu PIN: desde ese momento te pediremos el código de la app.",
  security_upgrade_pick: "¿Quieres más seguridad?",
  security_method_totp_sub_upgrade: "Más seguro que el PIN: el código vive en tu celular y cambia cada 30 s.",
  security_method_tag_recommended_secure: "RECOMENDADO · MÁS SEGURO",
  security_method_pin_name: "PIN de seguridad",
  security_method_pin_sub:
    "Seis dígitos que tú eliges. Listo en un minuto, aunque es menos seguro que la app.",
  security_method_pin_sub_active: "Es tu método actual.",
  security_method_tag_active: "ACTIVO",
  security_method_tag_fastest: "MÁS RÁPIDO",
  security_methods_compare_note:
    "La app autenticadora es la opción más segura: el código cambia cada 30 segundos y solo está en tu celular. El PIN es más rápido de configurar; si empiezas con él, puedes pasarte a la app cuando quieras.",
  security_pin_setup_title: "Crear PIN de seguridad",
  security_pin_created_toast: "Tu PIN de seguridad está activo",
  security_pin_changed_toast: "Guardamos tu PIN nuevo",
  security_pin_removed_toast: "Quitaste tu PIN de seguridad",
  security_pin_remove_title: "¿Quitar tu PIN de seguridad?",
  security_pin_remove_body:
    "Sin PIN ni app autenticadora no podrás crear tarjetas, ver sus datos ni mover dinero hasta que configures uno de los dos.",
  security_pin_remove_confirm: "Quitar PIN",
  security_pin_remove_cancel: "Cancelar",
  security_totp_password_intro:
    "Primero confirma que eres tú: escribe tu contraseña y generamos el código QR para tu app.",
  security_totp_password_submit: "Generar código QR",
  security_totp_password_required: "Escribe tu contraseña.",
  security_totp_locked_title: "Confirmación en pausa",
  security_totp_locked:
    "Hubo 5 códigos incorrectos seguidos. Podrás confirmar acciones de nuevo en {{time}}.",
  security_email_backup_eyebrow: "Plan B",
  security_email_backup_title: "Respaldo por email",
  security_email_backup_sub_pin_on:
    "Activado: si olvidas tu PIN o está bloqueado, te enviamos un código a tu correo para confirmar la acción.",
  security_email_backup_sub_pin_off:
    "Desactivado: si olvidas tu PIN, tendrás que crear uno nuevo con tu contraseña antes de seguir.",
  security_email_backup_sub_totp_off:
    "Es un poco menos seguro que usar solo la app: quien entre a tu correo también podría confirmar acciones. Actívalo solo si quieres un plan B.",
  security_email_backup_sub_totp_on:
    "Activado: si no tienes tu celular a mano, te enviamos un código a tu correo. Quien entre a tu correo también podría confirmar acciones.",
  security_email_backup_sub_none:
    "Estará disponible cuando elijas la app autenticadora o un PIN: es el plan B de ese método, no un método por sí solo.",
  security_email_backup_destination: "Los códigos llegan a {{email}}",
  security_email_backup_tag_on: "Activado",
  security_email_backup_tag_off: "Desactivado",
  security_email_backup_tag_unavailable: "Aún no disponible",
  security_email_backup_switch_label: "Activar o desactivar el respaldo por email",
  security_email_backup_enable_title: "Activar respaldo por email",
  security_email_backup_disable_title: "Desactivar respaldo por email",
  security_email_backup_enable_body_pin:
    "Si algún día olvidas tu PIN o se bloquea, podrás pedir un código a {{email}} para confirmar la acción.",
  security_email_backup_enable_body_totp:
    "Si no tienes tu celular a mano, podrás pedir un código a {{email}}. Ten en cuenta que quien entre a tu correo también podría confirmar acciones.",
  security_email_backup_disable_body:
    "Solo podrás confirmar acciones con tu método principal. Si lo pierdes, tendrás que recuperarlo antes de seguir.",
  security_email_backup_password_intro: "Confirma con tu contraseña para guardar el cambio.",
  security_email_backup_cancel: "Cancelar",
  security_email_backup_enable_confirm: "Activar respaldo",
  security_email_backup_disable_confirm: "Desactivar respaldo",
  security_email_backup_enabled_toast: "Listo: el respaldo por email está activado.",
  security_email_backup_disabled_toast: "Listo: el respaldo por email está desactivado.",
  security_guide_title: "¿Cuál elijo?",
  security_guide_totp_label: "App autenticadora",
  security_guide_totp: "La más segura: un código nuevo en tu celular cada 30 segundos.",
  security_guide_pin_label: "PIN de seguridad",
  security_guide_pin: "La más rápida: seis dígitos que tú eliges, listos en un minuto.",
  security_guide_email_label: "Respaldo por email",
  security_guide_email: "El plan B: un código a tu correo cuando no tienes tu PIN o tu celular a mano.",
  security_method_pin_email_note: "Incluye respaldo por email",
  security_method_totp_email_note: "Respaldo por email opcional",

  // Access — permission board (areas, shortcuts, actions)
  access_area_money: "Dinero y pagos",
  access_area_money_hint: "Billeteras, cobros, pagos, conversiones y pagos por lotes.",
  access_area_cards: "Tarjetas",
  access_area_cards_hint: "Tarjetas, recargas y movimientos de saldo entre tarjetas.",
  access_area_clients: "Clientes",
  access_area_clients_hint: "Los clientes de tu organización y sus cuentas bancarias.",
  access_area_organization: "Organización y verificación",
  access_area_organization_hint:
    "Los datos de la organización, sus cuentas y la verificación de identidad (KYC).",
  access_area_team: "Equipo y accesos",
  access_area_team_hint: "Las personas de la cuenta, sus roles y las políticas de acceso.",
  access_area_developers: "Desarrolladores",
  access_area_developers_hint: "API keys y webhooks para integrarse con Coloca.",
  access_area_fees: "Comisiones",
  access_area_fees_hint: "Las comisiones y su configuración.",
  access_area_operations: "Operación interna",
  access_area_operations_hint:
    "Herramientas de backoffice de Coloca: confirmaciones, auditoría, cotizaciones y notas.",
  access_area_count_aria: "{{granted}} de {{total}} permisos",
  access_preset_label: "Rápido:",
  access_preset_none: "Nada",
  access_preset_read: "Solo ver",
  access_preset_readWrite: "Ver y editar",
  access_preset_all: "Todo",
  access_preset_sensitive_note:
    "Los permisos marcados como Sensible no entran en estos atajos: actívalos uno por uno.",
  access_module_sensitive: "Sensible",
  access_level_read: "Ver",
  access_level_write: "Editar",
  access_level_delete: "Eliminar",
  access_level_read_hint: "Consultar la información",
  access_level_write_hint: "Crear y modificar",
  access_level_delete_hint: "Borrar o anular",
  access_cell_covered: "Ya lo da otro rol o política seleccionada",
  access_cell_denied: "Bloqueado por una política que deniega",
  access_cell_unavailable: "No hay un permiso individual para esta acción",
  access_cell_risky: "Acción de alto impacto",
  access_board_search_placeholder: "Buscar permiso, p. ej. tarjetas",
  access_board_no_matches: "Ningún permiso coincide con la búsqueda.",
  access_effective_idle_one: "1 módulo más sin acceso",
  access_effective_idle: "{{count}} módulos más sin acceso",
  access_effective_no_access: "Sin acceso en: {{areas}}.",
  access_role_permissions_label: "Permisos del rol",
  access_role_permissions_hint:
    "Elige qué puede hacer el rol en cada área: usa un atajo o marca acción por acción.",
  access_role_other_policies: "Otras políticas",
  access_role_other_policies_hint:
    "Políticas que combinan varios permisos, o que bloquean un permiso aunque otra lo dé.",
  access_drawer_combined_roles: "Roles combinados",
  access_drawer_combined_hint: "Cada uno da varios permisos a la vez.",
  access_drawer_permissions_label: "Permisos por área",
  access_drawer_permissions_hint: "Cada casilla asigna el rol de ese permiso y se guarda al instante.",

  // Access — Settings roles and policies lists by area
  access_catalog_search_placeholder: "Buscar por nombre o permiso, p. ej. tarjetas",
  access_catalog_no_matches: "Nada coincide con la búsqueda.",
  access_roles_group_combined: "Roles combinados",
  access_roles_group_combined_note: "Roles de Coloca que dan varios permisos a la vez.",
  access_roles_group_basic: "Roles básicos por área",
  access_roles_group_basic_note: "Un rol por permiso. Toca una acción para ver el rol y quién lo tiene.",
  access_policies_group_basic: "Políticas básicas por área",
  access_policies_group_basic_note: "Una política por permiso, para armar roles. Toca una acción para verla.",
};
